import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-397310d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "shop flex-ter",
  style: {"border-top":"1px solid #E9E9E9"}
}
const _hoisted_2 = { style: {"font-size":"12px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "flex-ter"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_8 = {
  key: 2,
  class: "empower"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("     ")
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 1,
  class: "disabled-title flex"
}
const _hoisted_12 = { class: "fx-1" }
const _hoisted_13 = { class: "goods" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "shop-check" }
const _hoisted_16 = {
  key: 0,
  class: "flex-ter table-title rel"
}
const _hoisted_17 = { class: "flex-col flex-ter goods-pic-con" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { style: {"width":"200px"} }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "goods-title" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "fx-1" }
const _hoisted_25 = { style: {"width":"200px"} }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "goods-title" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 2,
  class: "rp-color abs notcan"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 以下の商品は、お取り扱いができませんのでご了承下さい"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 不明確な場合は仕入の前に、都度確認をお願い致します"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ➀著作権、特許権を侵害するもの"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ②麻薬、向精神薬、大麻、あへん、けしがら、覚醒剤"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ③けん銃、小銃、機関銃、砲、これらの銃砲弾及びけん銃部品"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ④爆発物"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ⑤火薬類"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ⑥貨幣類 ")
], -1))
const _hoisted_31 = { style: {"cursor":"pointer"} }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-wenhao1",
  style: {"vertical-align":"middle","margin-left":"5px"}
}, null, -1))
const _hoisted_33 = {
  key: 3,
  class: "rp-color abs notcan"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "shopcart-abnormal-tip" }
const _hoisted_40 = {
  key: 0,
  class: "abnormal-tip"
}
const _hoisted_41 = {
  class: "primary",
  style: {"padding":"10px 0","color":"#333333","max-width":"200px"}
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1" }, null, -1))
const _hoisted_43 = { class: "text" }
const _hoisted_44 = {
  key: 1,
  class: "slow-tip"
}
const _hoisted_45 = {
  class: "primary",
  style: {"padding":"10px 0","color":"#333333","max-width":"200px"}
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1" }, null, -1))
const _hoisted_47 = { class: "text" }
const _hoisted_48 = {
  key: 1,
  class: "flex-ter"
}
const _hoisted_49 = {
  key: 2,
  class: "goods-props"
}
const _hoisted_50 = { style: {"width":"200px"} }
const _hoisted_51 = {
  class: "line--2",
  style: {"box-sizing":"border-box","padding":"0 5px"}
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 3 }
const _hoisted_55 = {
  key: 0,
  class: "abs rp-color not-enough",
  style: {"color":"#FE2C55"}
}
const _hoisted_56 = {
  key: 1,
  class: "abs rp-color not-enough",
  style: {"color":"#FE2C55"}
}
const _hoisted_57 = {
  key: 2,
  class: "abs rp-color not-enough",
  style: {"color":"#FE2C55","max-width":"120px"}
}
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { key: 4 }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { key: 5 }
const _hoisted_65 = { key: 6 }
const _hoisted_66 = { key: 7 }
const _hoisted_67 = { class: "line--3" }
const _hoisted_68 = { style: {"max-width":"300px"} }
const _hoisted_69 = ["onClick"]
const _hoisted_70 = { class: "text-ct rel" }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { key: 8 }
const _hoisted_73 = ["onClick"]

import { ref, computed, watch, onMounted, reactive } from 'vue'
import { t } from '@/plugins/i18n'
import CheckBox from './CheckBox.vue'
import AmountSet from './AmountSet.vue'
import { formatMoney } from '@/plugins/utils'
import { changeSkuNum, changeMSku, deleteSku, addAdt } from '@/apis/shopcart'
import { confirmDeleteSku } from '@/util/useConfirm'
import GoodsLink from '@/components/common/GoodsLink.vue'
import GroupItem from './GroupItem.vue'
import ChangeSku from './ChangeSku.vue'
import LogoIcon from '@/components/common/LogoIcon.vue'
import { goodsPropName } from '@/util/useFormat'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { montageAddition, isConfirmWashAdditionCustomerSku } from '@/util/calcAdt'
import { BASE_IMAGE } from '@/common/baseImage'
import { codeName } from '@/components/BlackGoods/data'
import { useSite, isJA, useRtAffix, isD2C, isKO } from '@/store'
import Tipstishi from '@/components/IconPark/Tipstishi.vue'
import { sourceCountryRef, tCurrency } from '../country'
import { ElMessage, ElMessageBox } from 'element-plus'
import { COUNTRY } from '@/global'
import { ShopType } from '@/common/const'
import { useStore } from 'vuex'
interface Sku {
  cartId: string
  checked: boolean
  orderQuantity: number
  actualProductSellPrice: number
  actualTotalProductSellPrice: number
  notInStorage?: number
  shitProp?: boolean
  productStatus?: number
  stockQuantity: number
  productSku: string
}

export default /*#__PURE__*/_defineComponent({
  props: ['layout', 'data', 'checkMap', 'mode', 'choiceDisabled', 'list'],
  emits: ['update', 'calc'],
  setup(__props, { emit }) {

const props = __props



const store = useStore()
// tiktok店铺 直发模式 2c
const isJpWare = computed(() => Number(isD2C() && props.mode === 1 && sourceCountryRef.value === COUNTRY.JP))
const showTiktok = computed(() => Number(store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK && isD2C() && props.mode === 1)

const countryCode = computed(() => props.mode === 1 ? sourceCountryRef.value : (sourceCountryRef.value === COUNTRY.JP ? COUNTRY.CN : sourceCountryRef.value))

const getLackInventory = (goods: any) => {
  if (checkMapRef.value[goods.cartId] && props.mode === 1 && (showTiktok.value || isJpWare.value)) {
    if (goods.productType === 3) {
      return goods.combinationProductItemList.some(i => i.buyQuantity > 0)
    } else {
      return goods.orderQuantity > goods.originalstockQuantity
    }
  }
  return false
}

const texts = ['变更', '编辑', '删除', '暂无'].map(t)
const prodLabels = ['检索平台', '检索平台', 'OEM商品', '组合商品']
  .map(t)
  .map((v, i) => (i < 2 ? v + '：' : v))

const showAdditional = ref(1)
const additional = require('@/assets/image/additional.png')
const oparrows = require('@/assets/image/oparrows.png')

const isAdditional = () => {
  const additionalValue = localStorage.getItem('Additional')
  if (additionalValue) {
    showAdditional.value = 0
  } else {
    showAdditional.value = 1
  }
}

const goods = reactive(props.data.cartList)
const checkMapRef = computed(() => props.checkMap)
/** 获取组合商品html提示文案 */
const getCombinationGoodsHtml = (goods: any, mode: any) => {
  // mode为1代表直发单，goods.productStatus为0代表库存正常
  return goods.productStatus === 0 && mode && goods.buyQuantity > 0 ? t('库存过低不能下单，请调整发货量或及时补充库存') : ''
}

const setAdditional = () => {
  showAdditional.value = showAdditional.value === 1 ? 0 : 1
  localStorage.setItem('Additional', showAdditional.value + '')
}

onMounted(() => {
  if (!isD2C() && isKO()) {
    isAdditional()
  }
})

const checkAll = computed({
  get: () => props.data.cartList.every((item: Sku) => props.checkMap[item.cartId]),
  set: (val) => {
    emit('update', {
      type: 'check',
      val: [props.data.cartList.filter((item: Sku) => item.notInStorage === 0 && !item.shitProp).map((item: Sku) => item.cartId), val]
    })
  }
})

const isIndeterminate = computed(
  () =>
    !checkAll.value &&
    props.data.cartList.some((item: Sku) => props.checkMap[item.cartId])
)

const disabledAll = ref(false)
watch(() => props.data.cartList, (value: any) => {
  disabledAll.value = value.every((item: Sku) => {
    return item.notInStorage !== 0 || item?.shitProp
  })
}, {
  immediate: true,
  deep: true
})
watch(() => props.mode, () => {
  // 切换mode校验每一个店铺的全选按钮禁用状态
  disabledAll.value = props.data.cartList.every((item: Sku) => {
    return item.notInStorage !== 0 || item?.shitProp
  })
}, {
  immediate: true
})
const handleChange = (num: number, goods: Sku) => {
  const old = goods.orderQuantity
  goods.orderQuantity = num
  // 如果是直发需要把cartId传过去
  emit('calc', (goods.productStatus === 1 || goods.productStatus === 2) && props.mode && (goods.orderQuantity > goods.stockQuantity) ? goods.cartId : '')
  changeSkuNum({ cartId: goods.cartId, orderQuantity: num }).then((res) => {
    if (!res.success) {
      goods.orderQuantity = old
      emit('calc', (goods.productStatus === 1 || goods.productStatus === 2) && props.mode && (goods.orderQuantity > goods.stockQuantity) ? goods.cartId : '')
    }
  })
}
const updateMSku = (goods: any) => {
  changeMSku(goods).then((res) => {
  })
}

const handleDel = (goods: Sku) => {
  confirmDeleteSku(
    () => {
      deleteSku({ cartIdList: [goods.cartId] }).then(() => {
        emit('update', { type: 'delete', val: goods })
      })
    },
    () => { }
  )
}

const oemType = (type: any) => {
  return t([1, 3].includes(type) ? '样品单' : '大货单')
}

const canAddAdt = (goods: any) => {
  if (goods.productType === 2) {
    if (
      ([2, 4].includes(goods.oemOrderType) &&
        goods.oemProductClassificationId !== 3) || goods.cartAdditionList?.length
    ) {
      return true
    } else {
      goods.noAdditionalFlag = 1
    }
  } else {
    return true
  }
}

const proxy: any = ref({})
const changeAdt = (goods: any) => {
  proxy.value = {
    ...goods,
    cartAdditionList: goods.cartAdditionList ?? []
  }
}
const handleAdt = (t: any, cartId = proxy.value.cartId, goods = proxy) => {
  const cartAdditionList = Array.isArray(t) ? t : []
  const noAdditionalFlag = t === 1 ? t : 0
  addAdt({
    cartId,
    cartAdditionList,
    noAdditionalFlag
  }).then(() => {
    emit('update', {})
  })
}
const noAdd = (goods: any) => {
  handleAdt(1, goods.cartId, goods)
}
const choiceTip = () => {
  if (props.choiceDisabled) {
    ElMessage.warning(t('购物车代采商品和一口价商品不支持一起递交订单付款，请您按照商品类型依次提交订单完成付款操作'))
  }
}
const clearInvalGoods = () => {
  ElMessageBox.confirm(t('是否清空失效商品'), t('提示'), {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消'),
    type: 'warning'
  }).then(() => {
    deleteSku({ cartIdList: props.data?.cartList.map(v => v.cartId) }).then(() => {
      emit('update', {})
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (!__props.data.invalidGoods)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(CheckBox, {
              modelValue: _unref(checkAll),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checkAll) ? (checkAll).value = $event : null)),
              indeterminate: _unref(isIndeterminate),
              disabled: __props.choiceDisabled || disabledAll.value,
              onClick: _withModifiers(choiceTip, ["stop"])
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('全选')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "indeterminate", "disabled", "onClick"]),
            (__props.data.cartList[0].channel !== 5)
              ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(_unref(prodLabels)[__props.data.cartList[0].productType]), 1))
              : _createCommentVNode("", true),
            (__props.data.cartList[0].productType === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (__props.data.cartList[0].channel !== 5)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createVNode(LogoIcon, {
                          class: "mr_5",
                          type: __props.data.cartList[0].productCode?.slice(0, 2),
                          underline: __props.data.cartList[0].channel === 5,
                          country: _unref(sourceCountryRef)
                        }, null, 8, ["type", "underline", "country"]),
                        _createElementVNode("span", null, _toDisplayString(__props.data.cartGroupName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (__props.data.brandHasReleased === 1 && __props.data.brandStatus !== 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _hoisted_6,
                        _createVNode(_component_el_tag, { type: "info" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('品牌已下架')), 1)
                          ]),
                          _: 1
                        }),
                        _hoisted_7
                      ]))
                    : (__props.data.brandAuthStatus === 0 && __props.data.brandHasReleased === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _hoisted_9,
                          (__props.data.isAuthorizing)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 0,
                                type: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('申请中')), 1)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_el_tag, { type: "warning" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('未授权_')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("a", {
                                  style: {"padding-left":"4px","margin-top":"1px"},
                                  href: _unref(useRtAffix)() + `brandauth?brand=${__props.data.brandId}`,
                                  class: "empower-a"
                                }, _toDisplayString(_unref(t)('前往授权>')), 9, _hoisted_10)
                              ], 64))
                        ]))
                      : _createCommentVNode("", true)
                ], 64))
              : (__props.data.cartList[0].productType === 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('寻源单号')) + "：", 1),
                    _createElementVNode("span", null, _toDisplayString(__props.data.cartGroupNo), 1)
                  ], 64))
                : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('失效商品')), 1),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", {
                class: "inval",
                onClick: clearInvalGoods
              }, _toDisplayString(_unref(t)('清空失效商品')), 1)
            ])
          ])),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.cartList, (goods) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: goods.cartId
          }, [
            _createElementVNode("div", {
              id: goods.cartId,
              class: _normalizeClass(["flex-ter goods-item rel", { shit: goods.shitProp || goods.notInStorage !== 0 }])
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_checkbox, {
                  disabled: __props.choiceDisabled || goods.shitProp || goods.notInStorage !== 0,
                  modelValue: _unref(checkMapRef)[goods.cartId],
                  "onUpdate:modelValue": ($event: any) => ((_unref(checkMapRef)[goods.cartId]) = $event),
                  onClick: choiceTip
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.layout, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: v.label,
                  class: _normalizeClass({ 'fx-1': v.width === 'auto' }),
                  style: _normalizeStyle({ width: v.width + 'px' })
                }, [
                  (v.name === 'title')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (goods.notInStorage === 0 && !goods.shitProp)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(GoodsLink, { goods: goods }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("img", {
                                      referrerPolicy: "no-referrer",
                                      class: "goods-pic img-active",
                                      src: goods.productSkuImg?.split(',')[0] || goods.productMainImg || _unref(BASE_IMAGE),
                                      alt: ""
                                    }, null, 8, _hoisted_18)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["goods"]),
                              _createVNode(GoodsLink, {
                                goods: goods,
                                class: "fx-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_tooltip, {
                                    effect: "light",
                                    placement: "top"
                                  }, {
                                    content: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_19, [
                                        _createTextVNode(_toDisplayString(goods.productTitleJp) + " ", 1),
                                        (goods.oemOrderType)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, " (" + _toDisplayString(oemType(goods.oemOrderType)) + ") ", 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_21, [
                                        _createTextVNode(_toDisplayString(goods.productTitleJp) + " ", 1),
                                        (goods.oemOrderType)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " (" + _toDisplayString(oemType(goods.oemOrderType)) + ") ", 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["goods"])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("img", {
                                referrerPolicy: "no-referrer",
                                class: "goods-pic img-active",
                                src: goods.productSkuImg?.split(',')[0] || goods.productMainImg || _unref(BASE_IMAGE),
                                alt: ""
                              }, null, 8, _hoisted_23),
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_el_tooltip, {
                                  effect: "light",
                                  placement: "top"
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_25, [
                                      _createTextVNode(_toDisplayString(goods.productTitleJp) + " ", 1),
                                      (goods.oemOrderType)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, " (" + _toDisplayString(oemType(goods.oemOrderType)) + ") ", 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_27, [
                                      _createTextVNode(_toDisplayString(goods.productTitleJp) + " ", 1),
                                      (goods.oemOrderType)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, " (" + _toDisplayString(oemType(goods.oemOrderType)) + ") ", 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ], 64)),
                        (goods.notInStorage !== 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                              _createVNode(_component_el_tooltip, {
                                placement: "bottom",
                                effect: "light"
                              }, {
                                content: _withCtx(() => [
                                  _hoisted_30
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_31, [
                                    _createTextVNode(_toDisplayString(_unref(t)('不可代购')), 1),
                                    _hoisted_32
                                  ])
                                ]),
                                _: 1
                              })
                            ]))
                          : (goods.shitProp)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                                (_unref(sourceCountryRef) === 'CN' && goods.purchaseCountry === 'JP')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_unref(t)('超出库存，无法下单')), 1))
                                  : (goods.blackTag === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_unref(codeName)[goods.blackReasonCode]?.normal), 1))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createElementVNode("span", {
                                          innerHTML: goods.productStatus === 1 ? (goods.buyQuantity > 0 && goods.originalstockQuantity > 0 && __props.mode ? _unref(t)('商品已失效，请调整商品或发货量') : _unref(t)('已失效_')) : goods.productStatus === 2 ? (goods.buyQuantity > 0 && goods.originalstockQuantity > 0 && __props.mode ? _unref(t)('商品已下架，请调整商品或发货量') : _unref(t)('已下架')) : goods.productStatus === 3 ? _unref(t)('库存过低不能下单，请调整发货量或及时补充库存') : ''
                                        }, null, 8, _hoisted_36),
                                        (goods.productType === 3 ? goods.combinationProductItemList.some((v) => v.productStatus === 1) : false)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              innerHTML: _unref(t)('商品已失效，请调整商品或发货量')
                                            }, null, 8, _hoisted_37))
                                          : _createCommentVNode("", true),
                                        (goods.productStatus === 7)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_unref(t)('已失效_')), 1))
                                          : _createCommentVNode("", true)
                                      ], 64))
                              ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_39, [
                          (goods.showDefectiveStatus === 1 || goods.showDefectiveStatus === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                _createVNode(_component_el_tooltip, {
                                  placement: "bottom",
                                  effect: "light",
                                  "popper-class": "tool-tip-no-border",
                                  offset: 10
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(t)('※商品不良包含：次品、到错货、多件/少件情况。')), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _hoisted_42
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(t)('不良率高')), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (goods.showDeliveryTimeStatus === 3)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                _createVNode(_component_el_tooltip, {
                                  placement: "bottom",
                                  effect: "light",
                                  "popper-class": "tool-tip-no-border",
                                  offset: 10
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(t)('※回货时长超过15天。')), 1)
                                  ]),
                                  default: _withCtx(() => [
                                    _hoisted_46
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(t)('出荷遅延率高')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (v.name === 'customSku')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createVNode(_component_el_input, {
                            modelValue: goods.customerProductMsku,
                            "onUpdate:modelValue": ($event: any) => ((goods.customerProductMsku) = $event),
                            modelModifiers: { trim: true },
                            maxlength: "100",
                            onBlur: ($event: any) => (updateMSku(goods)),
                            disabled: goods.notInStorage !== 0 || goods.shitProp
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "disabled"])
                        ]))
                      : (v.name === 'sku')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            (goods.productPropertiesName)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goodsPropName)(goods), (v) => {
                                    return (_openBlock(), _createElementBlock("div", { key: v }, [
                                      _createVNode(_component_el_tooltip, {
                                        effect: "light",
                                        placement: "top"
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_50, _toDisplayString(v?.replace('颜色', _unref(t)('颜色2'))?.replace('尺码', _unref(t)('尺码'))), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_51, _toDisplayString(v?.replace('颜色', _unref(t)('颜色2'))?.replace('尺码', _unref(t)('尺码'))), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  }), 128)),
                                  (goods.notInStorage === 0)
                                    ? (_openBlock(), _createBlock(ChangeSku, {
                                        key: 0,
                                        data: goods,
                                        onUpdate: _cache[1] || (_cache[1] = ($event: any) => (emit('update', {})))
                                      }, {
                                        default: _withCtx(() => [
                                          (goods.productType === 1)
                                            ? (_openBlock(), _createElementBlock("label", {
                                                key: 0,
                                                class: "btn primary-color",
                                                onClick: ($event: any) => (goods.replace = true),
                                                style: {"color":"#0586FE"}
                                              }, _toDisplayString(_unref(texts)[0]), 9, _hoisted_52))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["data"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : (_openBlock(), _createElementBlock("span", _hoisted_53, "-"))
                          ]))
                        : (v.name === 'amount')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                              (goods.notInStorage === 0)
                                ? (_openBlock(), _createBlock(AmountSet, {
                                    key: 0,
                                    amount: goods.orderQuantity,
                                    min: 1,
                                    "onUpdate:amount": (e) => handleChange(e, goods),
                                    disabled: goods.notInStorage !== 0 || (goods.shitProp && (__props.mode === 1 && goods.restQuantity === 0 || __props.mode === 0)),
                                    goods: goods
                                  }, {
                                    default: _withCtx(() => [
                                      (goods.lack)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_unref(t)('购买数量不可低于X件').replace('X', goods.minOrderQuantity)), 1))
                                        : (goods.handLack && goods.batchNumber > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_unref(t)('按手起批 1手={num}双', { num: goods.batchNumber })), 1))
                                          : (getLackInventory(goods))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_unref(t)(`超出库存，无法下单，请先提前备货到${_unref(sourceCountryRef) === _unref(COUNTRY).JP ? '日本仓' : '中国仓'}`)), 1))
                                            : _createCommentVNode("", true),
                                      _withDirectives(_createElementVNode("div", {
                                        class: _normalizeClass(["one-send-warn abs", _unref(useSite)()])
                                      }, [
                                        _createElementVNode("div", {
                                          innerHTML: _unref(t)('建议订购数：{num}', { num: goods.minOrderQuantity })
                                        }, null, 8, _hoisted_58),
                                        _createElementVNode("div", {
                                          innerHTML: _unref(t)('可享批发优惠价')
                                        }, null, 8, _hoisted_59)
                                      ], 2), [
                                        [_vShow, goods.onePsaleLack]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["amount", "onUpdate:amount", "disabled", "goods"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(goods.orderQuantity), 1))
                            ]))
                          : (v.name === 'store')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                (_unref(showTiktok) || _unref(isJpWare))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                      _createTextVNode(_toDisplayString(__props.checkMap[goods.cartId] ? goods.stockQuantity : '-') + " ", 1),
                                      _createElementVNode("span", null, "/" + _toDisplayString(goods.originalstockQuantity ?? 0), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                      _createTextVNode(_toDisplayString(__props.checkMap[goods.cartId] ? goods.stockQuantity : '-') + " ", 1),
                                      _createElementVNode("span", null, "/" + _toDisplayString(goods.buyQuantity ?? 0), 1)
                                    ]))
                              ]))
                            : (v.name === 'price')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                  _createElementVNode("div", null, _toDisplayString(goods.buyQuantity > 0 && (!_unref(showTiktok) && !_unref(isJpWare)) ? _unref(formatMoney)(goods.price) : '-'), 1)
                                ]))
                              : (v.name === 'total')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                    _createElementVNode("div", null, _toDisplayString(goods.buyQuantity > 0 && (!_unref(showTiktok) && !_unref(isJpWare)) ? _unref(formatMoney)(goods.totalPrice) : '-'), 1)
                                  ]))
                                : (v.name === 'adt')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                      (canAddAdt(goods) && (!(__props.mode === 1 && _unref(sourceCountryRef) === _unref(COUNTRY).JP)))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (goods.additionNameJpSummary)
                                              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                  key: 0,
                                                  placement: "top",
                                                  effect: "light"
                                                }, {
                                                  content: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_68, _toDisplayString(_unref(montageAddition)(goods.productType === 3 ? goods.combinationProductAdditionList :
                        goods.cartAdditionList)), 1)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_67, _toDisplayString(_unref(montageAddition)(goods.productType === 3 ? goods.combinationProductAdditionList :
                      goods.cartAdditionList)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              : _createCommentVNode("", true),
                                            (goods.productType !== 3 && goods.notInStorage === 0 && !goods.shitProp)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                  _createElementVNode("label", {
                                                    class: "btn primary-color",
                                                    onClick: ($event: any) => (changeAdt(goods)),
                                                    style: {"color":"#0586FE"}
                                                  }, _toDisplayString(_unref(texts)[1]), 9, _hoisted_69),
                                                  _createElementVNode("div", _hoisted_70, [
                                                    _withDirectives(_createVNode(_component_el_radio, {
                                                      "model-value": !!goods.noAdditionalFlag,
                                                      size: "small",
                                                      label: true,
                                                      style: {"margin-right":"0"},
                                                      onChange: ($event: any) => (noAdd(goods))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["model-value", "onChange"]), [
                                                      [_vShow, !goods.cartAdditionList?.length]
                                                    ]),
                                                    _withDirectives(_createElementVNode("div", {
                                                      class: _normalizeClass(["abs add-valid-text", { active: goods.showTip }])
                                                    }, _toDisplayString(_unref(t)('附加项验证')), 3), [
                                                      [_vShow, !(goods.cartAdditionList?.length || goods.noAdditionalFlag)]
                                                    ])
                                                  ])
                                                ], 64))
                                              : _createCommentVNode("", true)
                                          ], 64))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_71, "-"))
                                    ]))
                                  : (v.name === 'run')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                        _createElementVNode("label", {
                                          class: "btn fcolor",
                                          onClick: ($event: any) => (handleDel(goods)),
                                          style: {"color":"#0586FE"}
                                        }, _toDisplayString(_unref(texts)[2]), 9, _hoisted_73)
                                      ]))
                                    : _createCommentVNode("", true)
                ], 6))
              }), 128))
            ], 10, _hoisted_14),
            (goods.productType === 3)
              ? (_openBlock(), _createBlock(GroupItem, {
                  key: 0,
                  checked: __props.checkMap[goods.cartId],
                  mode: __props.mode,
                  list: goods.combinationProductItemList,
                  onUpdate: _cache[2] || (_cache[2] = ($event: any) => (emit('update', {})))
                }, null, 8, ["checked", "mode", "list"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (proxy.value.cartAdditionList)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              list: proxy.value.cartAdditionList,
              "onUpdate:list": _cache[3] || (_cache[3] = ($event: any) => ((proxy.value.cartAdditionList) = $event)),
              proxy: proxy.value,
              countryCode: _unref(countryCode),
              onCommit: handleAdt,
              type: "AdtOrder",
              title: _unref(t)('商品オプション設定'),
              isConfirmKey: true
            }, null, 8, ["list", "proxy", "countryCode", "title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }))
  ], 64))
}
}

})